module.exports = __webpack_public_path__ + "static/media/painel.8288ee32.jpg";